import {Basics} from './basics';
import {searchFormHelpers} from './search_form_helpers';
import {MapPositionStorage} from './../search_results/map_position_storage';


var $input;
var $sparkql;
var $viewResultsButton;

var formSelector = '#list_container_form';
var omniSearchUrl;


function init() {

  omniSearchUrl = $('.addressSearchContent').attr('data-omni-search-url');

  Basics.previous_mls_ids = Basics.mls_id().val();

  // Relative Date support
  $(document).on('click', '.exchange_icon', function() {
    searchFormHelpers.toggleDateRelativity($(this));
    searchFormHelpers.findCount();
  });
  
  // when the location box changes, this will update the view results button
  window.addEventListener('searchForm:filterChanged', function(e) {
    searchFormHelpers.updateViewResultsHref(e.detail);
  });

  window.addEventListener('searchForm:fieldsReloaded', function(e) {
    setupForm();
  });

  $('#content').show();
  hidePageLoadingMsg();

  setupForm();
  Basics.bind_selects();
}

function setupForm() {
  setupLocationSearch();

  $('select').not('#locationSearch').each(function() {
    if($(this).prop('multiple')){
      $(this).flexSelect2();
    }
  });

  Basics.update_status_date_fields();
}

function setupLocationSearch(){

  var $form = $(formSelector);
  $input = $form.find('#searchInput');
  $sparkql = $form.find('#sparkqlInput');

  $viewResultsButton = $('.view-results');

  bindInput();

  MapPositionStorage.deleteByPrefix('AddressSearch');
}

function bindInput() {
  $input.keyup( $.debounce(500, handleInput) );
}

function handleInput() {
  var queryText = $input.val();

  if(queryText && queryText.length > 1){

    // quick_launch doesn't support PropertyClasses, but we can try to send the PropertyType.
    var propertyTypeValues = $('#search_fields_PropertyType_value').val();
    var mlsIdValues = $('#search_fields_MlsId_value').val();

    showPageLoadingMsg();
    $viewResultsButton.html('Getting results...').addClass('disabled');

    var data = {
      _q: queryText,
      _sas: true
    };

    if(propertyTypeValues){
      data._pt = propertyTypeValues.join(',');
    }

    if(mlsIdValues){
      data._mls = mlsIdValues.join(',');
    }

    $.ajax({
      url: omniSearchUrl,
      data: data,
      dataType: 'jsonp',
      success: function(data, textStatus, jqXHR){
        $sparkql.val(data.D.SimpleAddressSearchSparkQl);
        searchFormHelpers.findCount();
      },
      error: function(data, textStatus, jqXHR) {
        alertModal("Error running search");
      },
      complete: function(){
        hidePageLoadingMsg();
      }
    });
  }
}

export var addressSearch = {
  init: init
};

